function HolidayViewPage() {
	return <div>OutletHoliday</div>;
}

export default HolidayViewPage;
